import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { dataHooks } from './FillPreview.constants';

export const fillPreviewDriverFactory = (base: UniDriver) => {
  const buttonSelector = `[data-hook="${dataHooks.button}"]`;

  return {
    ...baseUniDriverFactory(base),
    /** clicks on button */
    click: () => base.$(buttonSelector).click(),
    /** returns true if item is selected */
    isSelected: async () => {
      const dataSelected = await base.$(buttonSelector).attr('data-selected');

      return dataSelected === 'true';
    },
  };
};

export type FillPreviewUniDriver = ReturnType<typeof fillPreviewDriverFactory>;
